<template>
  <h1
    class="text-secondary mb-3"
  >{{moduleData.dashboard_title}}</h1>

<div
  v-if="
    moduleData.action
    && Object.keys(moduleData.action).length > 0
  "
  class="mb-3"
>
  <router-link
      v-for="(btnItem, btnIndex)  in moduleData.action"
      :to="btnItem.path"
      class="btn btn-warning me-2 mb-2 fw-medium"
  >
    <i v-if="btnItem.ico" :class="btnItem.ico + '  me-1'"></i>
    <span v-if="btnItem.title">{{btnItem.title}}</span>
  </router-link>
</div>

  <template
    v-for="(block) in moduleData.data"
  >
    <dashboard-item
      :dashboard="block"
    ></dashboard-item>
  </template>



  <!--


  <component
      v-bind:is="moduleData.view"
      :title="moduleData.title"
      :dataObj="moduleData.dataFormat"
      :dataFormated="moduleData.dataFormated"
      :btns="moduleData.btns"
      v-model:reloadSignal="reloadSignalList"
  ></component>
  -->
</template>

<script>
import { defineAsyncComponent } from 'vue';
import DashboardItem from "@/components/dashboard/Dashboard.vue";

export default {
  name: "DashboardUniversalModule",
  components: {
    DashboardItem,
  },
  emits: [
    "update:reloadSignal"
  ],
  props: {
    "ident": String,
    "reloadSignal": String,
    "moduleData": Object,
    "returnData": Object,
    "route": Object,
    "config": [Object],
  },
  data() {
    return {
      myComponentName: 'Goal', // Název komponenty uložený v proměnné
      reloadSignalBox: null,
      reloadSignalList: null
    }
  },
  methods: {
      reloadParent(val) {
        this.$emit("update:reloadSignal", val);
      }
  },
  watch: {
    reloadSignalBox: {
      handler(val) {
        //this.reloadParent(val);
      },
      immediate: true
    },
    reloadSignalList: {
      handler(val) {
        this.reloadParent(val);
      },
      immediate: true
    },
  },
  created() {
    if(
        !!this.$options.components[this.moduleData.view]
    ){
      this.moduleData.view = 'ViewGeneral';
    }
    this.isDefined = !!this.$options.components[this.moduleData.view];
  },
  mounted() {
   // console.log("dev DashboardModule mounted x")
  }
};
</script>